<script lang="ts" setup>
import { toTypedSchema } from '@vee-validate/zod';
import { useField } from 'vee-validate';
import { inject, ref } from 'vue';
import { z } from 'zod';
import { SUREbusinessCommonDomainRechtsvormEnum as Rechtsvorm } from '@services/crm-public/orval-api/model/sUREbusinessCommonDomainRechtsvormEnum';
import VSelect from '@shared/form/VSelect/VSelect.vue';
import FieldRowV2 from '@shared/form/FieldRowV2/FieldRowV2.vue';
import {
  hideRequiredAsteriskInjectionKey,
  isDisabledInjectionKey,
  isReadonlyInjectionKey,
} from '../keys';
import { useRechtsvormSelect } from '../../services/useRechtsvormSelect';

const { value: hasDisabledParent } = inject(isDisabledInjectionKey, { value: ref(false) });
const { value: hasReadonlyParent } = inject(isReadonlyInjectionKey, { value: ref(false) });
const { value: hideRequiredAsteriskParent } = inject(hideRequiredAsteriskInjectionKey, {
  value: ref(false),
});
const { errors, value } = useField('rechtsvorm', toTypedSchema(z.nativeEnum(Rechtsvorm)));
const fieldId = 'relatiegegevens-relatie-rechtsvorm';

const { modelValue, options, props } = useRechtsvormSelect(value);
</script>

<template>
  <FieldRowV2
    :errors="errors"
    label="Rechtsvorm"
    :required="!hideRequiredAsteriskParent && !hasReadonlyParent"
    :label-for="fieldId"
    v-bind="$attrs"
  >
    <VSelect
      v-if="!hasReadonlyParent"
      :data-testid="fieldId"
      class="w-full"
      v-model="modelValue"
      :options="options"
      v-bind="props"
      :disabled="hasDisabledParent"
      :readonly="hasReadonlyParent"
    />
    <div v-else>
      {{ modelValue?.omschrijving ?? '-' }}
    </div>
  </FieldRowV2>
</template>
